<template>
  <model-table
    :collection="tips"
    :show-add="false"
    :show-edit="false"
    :columns="[
      { field: 'id' },
      { name: 'order', field: tip => tip.orderItem.order, component: 'model' },
      { field: 'employee', component: 'model', classes: 'sensitive-column' },
      { name: 'source', field: tip => $_.startCase(tip.source), component: 'chip' },
      { name: 'state', field: tip => $_.startCase(tip.state), component: 'chip' },
      { name: 'paymentType', field: tip => $_.startCase(tip.paymentType), component: 'chip' },
      { field: 'amount', component: 'money' },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
  >
    <tip-form />
  </model-table>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import TipForm from 'src/modules/admin/tip/TipForm'

export default {
  name: 'TipTable',
  components: {
    ModelTable,
    TipForm
  },
  models: {
    tips: {
      employee: {
        fields: ['id', 'firstName', 'lastName']
      },
      orderItem: {
        fields: ['id'],
        order: {
          fields: ['id']
        }
      },
      tipPoolTip: {
        fields: ['id'],
        tipPoolType: {
          fields: ['id', 'name']
        }
      },
      variables () {
        return {
          noCount: true
        }
      }
    }
  }
}
</script>
